import {Component, Input, OnInit} from '@angular/core';
import {NzModalRef, NzModalService, NzNotificationService} from 'ng-zorro-antd';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-popup-accept-agent',
  templateUrl: './popup-accept-agent.component.html',
  styleUrls: ['./popup-accept-agent.component.scss']
})
export class PopupAcceptAgentComponent implements OnInit {
  @Input() nameAgent: any;
  @Input() type: any;
  reason: any;
  reasonList = [
    {
      label: 'Thiếu thông tin',
      isCheck: false
    },
    {
      label: 'Phát hiện bất thường',
      isCheck: false
    },
    {
      label: 'Không đạt yêu cầu',
      isCheck: false
    }
  ];

  formAgent: FormGroup;

  constructor( public modalRef: NzModalRef<PopupAcceptAgentComponent>,
               private modalService: NzModalService,
               private fb: FormBuilder,
               private notificationService: NzNotificationService) {
  }

  ngOnInit(): void {

    this.formAgent = this.fb.group({
      reason: [null, this.type === 'reject' ? [Validators.maxLength(500), Validators.required] : []]
    });
  }

  onChangeReason(index: number) {
    this.reasonList[index].isCheck = !this.reasonList[index].isCheck;
    // const reasonList = this.reasonList.filter(item => item.isCheck).map(i => (i.label));
    const reason = (this.formAgent.get('reason').value ? this.formAgent.get('reason').value : '') + (this.reasonList[index].isCheck ? this.reasonList[index].label + ', ' : '');
    this.formAgent.get('reason').patchValue(reason);
  }

  onConfirm(type?) {
    for (const i in this.formAgent.controls) {
      this.formAgent.controls[i].markAsDirty();
      this.formAgent.controls[i].updateValueAndValidity();
    }
    if (this.type === 'reject' && !this.formAgent.valid && type === 'confirm') {
      // this.notificationService.error('Thông báo', 'Vui lòng nhập lý do.');
      // this.notificationService.error('Thông báo', 'Lý do từ chối không được để trống');
      return;
    }

    if (this.type === 'reject' && this.formAgent.get('reason').value && !this.formAgent.get('reason').value.trim().length) {
      this.notificationService.error('Thông báo', 'Lý do từ chối không được để trống');
      return;
    }
    this.modalRef.close({
      type,
      reason: this.formAgent.get('reason').value ? this.formAgent.get('reason').value.trim() : ''
    });
  }
}
